import { Link } from "react-router-dom";
import { XCircle, Phone } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="bg-linen text-ink font-sans min-h-screen flex items-center justify-center px-6"
    >
      <div className="bg-white border border-cream rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        <XCircle className="w-12 h-12 text-moss mx-auto mb-4" />
        <h1 className="font-display text-2xl text-ink mb-2">Payment cancelled.</h1>
        <p className="text-sm text-moss mb-8">
          No charge was made. You can reserve your course place whenever you're ready, or send
          an enquiry and Elisabete will help you book in.
        </p>
        <div className="flex flex-col gap-3">
          <Link
            data-testid="back-to-pricing-link"
            to="/#pricing"
            className="px-6 py-3 rounded-full bg-forest text-linen text-xs font-semibold uppercase tracking-widest hover:bg-ink transition-colors"
          >
            Back to Course Fees
          </Link>
          <a
            data-testid="cancel-call-link"
            href="tel:+447479815308"
            className="px-6 py-3 rounded-full border border-forest/30 text-forest text-xs font-semibold uppercase tracking-widest hover:border-forest transition-colors flex items-center justify-center gap-2"
          >
            <Phone className="w-4 h-4" />
            Call +44 7479 815308
          </a>
        </div>
      </div>
    </div>
  );
}
